import { useEffect, useState } from 'react';

import { cn } from '@playbooks/ui/lib/utils';

const FlowFrame = ({ layout = 'default', children }) => {
	// Theme
	const rootClassName = cn(
		'relative w-full overflow-hidden',
		layout === 'panel' ? 'max-h-[min(24rem,var(--available-height))]' : 'h-full',
	);

	// Render
	return <div className={rootClassName}>{children}</div>;
};

const FlowBody = ({ children }) => {
	return <div className='min-h-0 flex-1 overflow-y-auto'>{children}</div>;
};

const FlowView = ({ direction = 'forward', children }) => {
	// State
	const [entered, setEntered] = useState(false);

	// Computed
	const offset = direction === 'backward' ? '-translate-x-4' : 'translate-x-4';

	// Hooks
	useEffect(() => {
		const frame = requestAnimationFrame(() => setEntered(true));
		return () => cancelAnimationFrame(frame);
	}, []);

	// Theme
	const rootClassName = cn(
		'flex-column max-h-[inherit] w-full overflow-hidden transition-all duration-200 ease-out',
		entered ? 'translate-x-0 opacity-100' : [offset, 'opacity-0'],
	);

	// Render
	return <div className={rootClassName}>{children}</div>;
};

export { FlowBody, FlowFrame, FlowView };
